import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { AnimationService, AnimationBuilder } from 'css-animator';

@Component({
  selector: 'welcome-event-user',
  templateUrl: 'welcome-event-user.html'
})
export class WelcomeEventUserComponent {

  @Input() showModalWelcome: boolean;

  @Input() config: any;

  @Input() userId: string;

  @Input() clientId: string;

  @Input() localstorageName: string;

  public showModal: boolean = false;

  private animatorModal: AnimationBuilder;

  @ViewChild('modalContainer') modalContainer: ElementRef;

  constructor(
    public animationService: AnimationService
  ) {

  }

  ngOnInit() {
    let valueView = window.localStorage.getItem(this.localstorageName);
    if (valueView !== "true") {
      this.showModal = true;
      setTimeout(() => {
        this.animatorModal = this.animationService.builder();
        // this.animatorModal.setType('fadeIn').show(this.modalContainer.nativeElement);
      }, 800);
    }
  }

  closeModal() {
    this.animatorModal.setType('fadeOut').hide(this.modalContainer.nativeElement);
    window.localStorage.setItem(this.localstorageName, "true");
    setTimeout(() => {
      this.showModal = false;
    }, 600);
  }

}



// WEBPACK FOOTER //
// ./src/components/welcome-event-user/welcome-event-user.ts